import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-72499bfc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "OrderReceivers" }
const _hoisted_2 = { class: "OrderReceivers__title block" }
const _hoisted_3 = { class: "OrderReceivers__list mt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_order_receivers_list_item = _resolveComponent("order-receivers-list-item")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, "Готовые грузы (" + _toDisplayString(_ctx.receivers.length) + ")", 1),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.receivers, (receiver, i) => {
        return (_openBlock(), _createBlock(_component_order_receivers_list_item, {
          key: receiver.id,
          receiver: receiver,
          index: i,
          disabled: _ctx.disabled,
          "without-update": _ctx.withoutUpdate,
          onUpdate: _ctx.emitUpdateCargo
        }, null, 8, ["receiver", "index", "disabled", "without-update", "onUpdate"]))
      }), 128))
    ])
  ]))
}